import axios from 'axios'
import store from '../store/index'

const websiteUrl = 'http://sa.eragood.com/IFSInterface/api/';
//const websiteUrl = 'http://api.sc.com/IFSInterface/api/';
//const websiteUrl = 'http://192.168.0.103:2048/api/';
//const websiteUrl = 'http://localhost:2502/api/';

axios.defaults.baseURL = websiteUrl

// axios请求拦截，为每一次调用API挂载Authorization请求头
axios.interceptors.request.use(config => {

    config.headers.Authorization = "Bearer " + store.getters.Token

    return config
})

axios.interceptors.response.use(response => {
    return response
  }, error => {
    return Promise.resolve(error.response)
  })

function checkStatus (response) {
    // loading
    // 如果http状态码正常，则直接返回数据
    if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
        return response
        // 如果不需要除了data之外的数据，可以直接 return response.data
    }
    // 异常状态下，把错误信息返回去
    return {
        status: -404,
        msg: '网络异常'
    }
}

function checkCode (res) {
    // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
    if (res.status === -404) {
        alert(res.msg)
    }
    if (res.data && (!res.data.success)) {
        alert(res.data.error_msg)
    }
    return res
}
// export default {
//     post (data,url) {
//       return axios({
//         method: 'post',
//         url: url,
//         data: qs.stringify(data),
//         timeout: 10000,
//         headers: {
//           'X-Requested-With': 'XMLHttpRequest',
//           'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
//         }
//       }).then(
//         (response) => {
//           return checkStatus(response)
//         }
//       )
//     },
//     get (url, params) {
//       return axios({
//         method: 'get',
//         baseURL: 'https://cnodejs.org/api/v1',
//         url,
//         params, // get 请求时带的参数
//         timeout: 10000,
//         headers: {
//           'X-Requested-With': 'XMLHttpRequest'
//         }
//       }).then(
//         (response) => {
//           return checkStatus(response)
//         }
//       ).then(
//         (res) => {
//           return checkCode(res)
//         }
//       )
//     }
//   }

export default axios
